<template>
  <div v-loading="loading">
    <div class="header">
      <el-button
        type="primary"
        @click="$router.push({ name: 'BudgetParamAdd' })"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="order_title" label="Qator sarlavhasi">
        <template #default="scope">
          <el-input
            v-model="scope.row.order_title"
            :autosize="{ minRows: 1, maxRows: 4 }"
            type="textarea"
          />
          
        </template>
      </el-table-column>
      <el-table-column prop="order_link" label="Qator havolasi" />
      <el-table-column prop="budget_year" label="Budjet yili" />

      <el-table-column prop="income" label="Daromad">
        <template #default="scope">
          {{ scope.row.income.toLocaleString("Ru-ru") }}
        </template>
      </el-table-column>
      <el-table-column prop="outcome" label="Xarajat">
        <template #default="scope">
          {{ scope.row.outcome.toLocaleString("Ru-ru") }}
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #default="scope">
          <el-button
            size="small"
            type="danger"
            @click="deleteBudgetParam(scope.row.id)"
            >O'chirish
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="
              $router.push({
                name: 'BudgetParamEdit',
                params: { id: scope.row.id },
              })
            "
            >Tahrirlash
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "BudgetParamsList",
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  methods: {
    getBudgetParams() {
      this.loading = true;
      this.$http
        .get(`api/v1/budget-params`)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lmumot yuklasda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteBudgetParam(id) {
      ElMessageBox.confirm("Parametrni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/budget-params/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getBudgetParams();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
  },
  mounted() {
    this.getBudgetParams();
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
</style>
